import { render, staticRenderFns } from "./CommissionTurnoverReportCreate.vue?vue&type=template&id=f0695918"
import script from "./CommissionTurnoverReportCreate.vue?vue&type=script&lang=js"
export * from "./CommissionTurnoverReportCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports